/*
==========================================================
ACTIVITY CATEGORIES
==========================================================
*/

export const activityCategories = {

  transportation: {

    label: "Transportation",

    color: "#2563EB"

  },

  adventure: {

    label: "Adventure",

    color: "#F59E0B"

  },

  rentals: {

    label: "Rental",

    color: "#10B981"

  }

};